document.addEventListener("DOMContentLoaded", () => {
	window.addEventListener("scroll", () => {
		document.querySelectorAll('.product__outer').forEach((elm) => {
			const height = elm.getBoundingClientRect();
			if (height.top < -650){
				document.querySelector('.sticky-addtocart').classList.contains('hidden') ? document.querySelector('.sticky-addtocart').classList.remove('hidden') : '';
			}else {
				!document.querySelector('.sticky-addtocart').classList.contains('hidden') ? document.querySelector('.sticky-addtocart').classList.add('hidden') : '';
			}
		});

	})
});